export enum UILayout {
  Table = 'table',
  Grid = 'grid'
}
